import { render, staticRenderFns } from "./DashboardTvSuporte.vue?vue&type=template&id=5a761b32"
import script from "./DashboardTvSuporte.vue?vue&type=script&lang=ts"
export * from "./DashboardTvSuporte.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTvSuporte.vue?vue&type=style&index=0&id=5a761b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports